import React from 'react';
import { Table, Tag, Empty } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { ClosingItem } from '../../../services/pw9614Api';

interface ResultTableProps {
  results: ClosingItem[] | null;
  processed: number;
  loading: boolean;
}

const columns: ColumnsType<ClosingItem> = [
  {
    title: '員工編號',
    dataIndex: 'empCode',
    key: 'empCode',
    width: 100,
    sorter: (a, b) => a.empCode.localeCompare(b.empCode),
  },
  {
    title: '員工姓名',
    dataIndex: 'empName',
    key: 'empName',
    width: 120,
  },
  {
    title: '假別',
    dataIndex: 'leaveType',
    key: 'leaveType',
    width: 80,
    render: (v: string) => <Tag color="blue">{v}</Tag>,
  },
  {
    title: '期初餘額',
    dataIndex: 'opening',
    key: 'opening',
    width: 100,
    align: 'right' as const,
    render: (v: number) => v.toFixed(1),
  },
  {
    title: '本月使用',
    dataIndex: 'taken',
    key: 'taken',
    width: 100,
    align: 'right' as const,
    render: (v: number) => (
      <span style={{ color: v > 0 ? '#cf1322' : undefined }}>{v.toFixed(1)}</span>
    ),
  },
  {
    title: '期末餘額',
    dataIndex: 'closing',
    key: 'closing',
    width: 100,
    align: 'right' as const,
    render: (v: number) => (
      <span style={{ color: v < 0 ? '#cf1322' : '#389e0d', fontWeight: 'bold' }}>
        {v.toFixed(1)}
      </span>
    ),
  },
];

const ResultTable: React.FC<ResultTableProps> = ({ results, processed, loading }) => {
  if (!results) {
    return <Empty description="請先執行預覽或月結作業" />;
  }

  return (
    <div>
      <div style={{ marginBottom: 8, color: '#666' }}>
        共處理 <strong>{processed}</strong> 位員工，
        產生 <strong>{results.length}</strong> 筆結果
      </div>
      <Table
        columns={columns}
        dataSource={results}
        rowKey={(r) => `${r.empCode}-${r.leaveType}`}
        loading={loading}
        size="small"
        pagination={{ pageSize: 50, showSizeChanger: true, showTotal: (t) => `共 ${t} 筆` }}
        scroll={{ y: 500 }}
      />
    </div>
  );
};

export default ResultTable;
